export default {
  light: {
    "desktop-header-cardmember-text-color": "primary-200",
    "desktop-header-control-text-color": "primary-500",
    "dotcom-header-contact-icon-background-color": "primary-300",
    "dotcom-header-desktop-placement-background-color": "neutral-700",
    "dotcom-header-mobile-accordion-icon-color": "primary-200",
    "dotcom-header-mobile-focus-border-color": "neutral-900",
    "dotcom-header-mobile-footer-border-color": "neutral-200",
    "footer-callout-header-text": "neutral-200",
    "footer-callout-phone-icon": "primary-500",
    "footer-content": "blue-1",
    "footer-separator": "neutral-500",
    "header-control-link": "blue-1",
    "header-link": "blue-1",
    "header-separator": "white",
    "primary-header-background": "white",
    "primary-header-heading-icon": "gray-4",
    "primary-header-horizontal-list-menu-background": "neutral-800",
    "primary-header-horizontal-list-menu-dark-background": "primary-300",
    "primary-header-logo": "blue-1",
    "primary-header-logo-light": "white",
    "primary-header-search": "blue-1",
    "primary-header-search-autocomplete": "blue-1",
    "primary-header-search-autocomplete-input": "blue-3",
    "primary-header-search-button": "blue-3",
    "primary-header-search-disabled": "gray-4",
    "primary-header-search-icon": "blue-3",
    "primary-header-search-label": "gray-4",
    "primary-header-search-open": "white",
    "primary-header-search-shadow": "gray-4",
    "search-autocomplete-button-background": "secondary-500",
    "search-autocomplete-button-border-color": "secondary-500",
    "search-autocomplete-button-focus-border-color": "primary-200",
    "search-autocomplete-button-text-color": "primary-200",
    "secondary-header-border": "blue-1",
    "secondary-header-login-prompt-background": "neutral-900",
    "secondary-header-login-prompt-border": "primary-500",
    "secondary-header-login-prompt-heading-color": "primary-500",
    "secondary-header-login-prompt-icon-color": "primary-800",
    "secondary-header-logo": "white",
    "secondary-header-logo-section-background": "blue-1",
    "secondary-header-navigation-link-section-background": "blue-1",
    "secondary-header-navigation-link-section-foreground": "gray-2",
    "secondary-header-options-background": "neutral-900",
    "secondary-header-title-section-background": "blue-2",
  },
  dark: {},
};
